import * as React from 'react';
import { Image, Pressable, StyleSheet, Text } from 'react-native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LocationDetails } from "./LocationDetails";
import { ProductDetails } from "./ProductDetails";
import { Delivery } from "./Delivery";
import * as AppConstants from "../context/AppConstants";
import * as AppUtilities from "../context/AppUtilities";
import { useSelector, useDispatch } from 'react-redux';
import { FilterSlider } from '../components/FilterSlider';
import { Header, getHeaderTitle } from '@react-navigation/elements';
import { HeaderLeft } from '../components/HeaderLeft';

const Stack = createNativeStackNavigator();

const styles = StyleSheet.create({
  mainImage: {
    width: 151,
    height: 38,
  },
  headerTopRightImage: {
    marginRight: 20,
    width: 25,
    height: 25,
  },
});

export function DeliveryStack() {
  const showHeader = useSelector((state) => state.showHeader);
  const showFilterSlider = useSelector((state) => state.showFilterSlider);

  let mainImage = <Image source={require('../../assets/delivery.png')} style={styles.mainImage} />;
  if (AppUtilities.isWeb()) {
    mainImage = <a href="/">{mainImage}</a>;
  }

  return (
    <Stack.Navigator
      screenOptions={({ navigation, route }) => ({
        headerRight: AppUtilities.getHeaderRight(navigation),
        headerTitle: (props) => <></>,
        detachPreviousScreen: false,
        animationEnabled: false,
        headerShown: showHeader,
        headerBackVisible: false,
        headerBackTitleVisible: false,
      })}
    >
      <Stack.Screen
        name={AppConstants.SCREENS.DELIVERY}
        component={Delivery}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} forceNoBackButton={true}>{mainImage}</HeaderLeft>,
          headerRight: () => showFilterSlider ? <FilterSlider vertical={false} /> : null,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.LOCATION_ONLINE_DETAILS}
        component={LocationDetails}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="Loading..." />,
          headerRight: () => showFilterSlider ? <FilterSlider vertical={false} /> : null,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.PRODUCER_ONLINE_DETAILS}
        component={LocationDetails}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="Loading..." />,
          headerRight: () => showFilterSlider ? <FilterSlider vertical={false} /> : null,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.PRODUCT_ONLINE_DETAILS}
        component={ProductDetails}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="Loading..." noFiltersRight={true} />,
        })}
      />
    </Stack.Navigator>
  );
}
